import { sendCommand } from './command.js';

function playSound({ soundsetName, action }) {
    return sendCommand({
        command: 'sound',
        params: {
            soundsetName,
            action,
        },
    });
}

export { playSound };
//# sourceMappingURL=play.js.map
